// API Configuration
const config = {
  // Production IFEC API for fetching report data
  apiUrl: process.env.REACT_APP_API_URL || 'https://authalt.bsynapse.com/ifeccustom',
  
  // Attendance API endpoint
  attendanceApiUrl: process.env.REACT_APP_ATTENDANCE_API_URL || 'https://apir4prod.bsynapse.com/ifeccustomguard/getattendance',
  
  // Backend API for email settings management
  // Uses production URL by default, can override with REACT_APP_BACKEND_URL for local dev
  backendUrl: process.env.REACT_APP_BACKEND_URL || 
    (window.location.hostname === 'localhost' 
      ? 'http://localhost:5001/api' 
      : `${window.location.protocol}//${window.location.host}/api`)
};

export default config;

